
define('jsx!components/lists/content-marketing',['jquery', 'underscore', 'react', 'event-manager', 'lib', 'classnames', 'pulse', 'track-visibility', 'stores/TeaserStore'], function($, _, React, eventManager, lib, classNames, Pulse, trackVisibility, TeaserStore) {
    'use strict';

    var PureRenderMixin = React.addons.PureRenderMixin;

    var ContentMarketing = React.createClass({displayName: "ContentMarketing",
        mixins: [PureRenderMixin],
        xhr: null,
        hasFetched: false,

        getDefaultProps: function() {
            return {
                placeholder: null,
                placement: null,
            };
        },

        getInitialState: function() {
            return {
                list: this.props.native || [],
                render: !!this.props.native,
                trackerId: 'elementTracker',
                tracker: null,
                deactivateVisibilityTracker: null,
            };
        },

        componentWillMount: function() {
            eventManager.on('fetchTeaser', this.updateList);
            if (this.props.native) {
                var native = this.props.native[0];

                _.each(
                    native.impressionTrackers,
                    _.bind(function (tracker) {
                        lib.loadImage(tracker);
                    }, this)
                );

                this.props.element.parentNode.className += ' has-native';
            } else {
                this.updateList();
            }
        },

        componentDidMount: function() {
            if (this.props.native) {
                this.adjustContainer();
            }
        },

        componentDidUpdate: function(prevProps, prevState) {
            if (this.state.render && this.state.render !== prevState.render) {
                this.initPulseImpressionTracker();

                var contentEl = this.refs.contentRef && this.refs.contentRef.getDOMNode();
                if (contentEl) {
                    contentEl.querySelectorAll('a').forEach(function (el) {
                        el.addEventListener('click', this.trackClick);
                    }.bind(this));
                }
            }
        },

        componentWillUnmount: function() {
            if (this.xhr) {
                this.xhr.abort();
            }
        },

        extractContentAdData: function(adObj) {
            var adObjDeviceProp = lib.isMobile()
                ? 'mobileVersion'
                : 'desktopVersion';
            if (!adObj || !adObj[adObjDeviceProp]) {
                return null;
            }

            var ad = adObj[adObjDeviceProp];

            TeaserStore.setTeaserIds(adObj.id);

            return {
                cssSource: ad.cssSource,
                htmlVersion: ad.htmlVersion,
                title: ad.title,
                url: ad.redirectUrl,
                customer: ad.clientName || 'Unknown customer',
                trackingPixel: ad.trackingPixel,
                teaserName: adObj.name || 'Missing teaser name',
            };
        },

        updateList: function() {
            if (this.hasFetched || TeaserStore.getTeaserIsFetching()) {
                return;
            }
            TeaserStore.setTeaserIsFetching(true);
            var excludedTeasers = TeaserStore.getTeaserIds();
            var baseUrl = 'https://content-studio-teasers-server.inventory.schibsted.io/e24-';
            var urlWithParams = baseUrl + this.props.placement + '?excludedTeasers=' + JSON.stringify(excludedTeasers);

            this.xhr = $.getJSON(urlWithParams)
                .done(
                    _.bind(function (adObj) {
                        var ad = this.extractContentAdData(adObj);

                        this.hasFetched = true;
                        TeaserStore.setTeaserIsFetching(false);

                        if (!ad) {
                            this.props.element.parentNode.removeChild(
                                this.props.element
                            );
                            if (this.props.placeholder) {
                                eventManager.emit(
                                    'collapse-native',
                                    this.props.placeholder
                                );
                            }

                            return;
                        }

                        this.setState({
                            list: [ad],
                            render: true,
                        });
                    }, this)
                )
                .fail(
                    _.bind(function () {
                        this.props.element.parentNode.removeChild(
                            this.props.element
                        );
                        if (this.props.placeholder) {
                            eventManager.emit(
                                'collapse-native',
                                this.props.placeholder
                            );
                        }

                        this.hasFetched = true;
                        TeaserStore.setTeaserIsFetching(false);
                    }, this)
                );
        },

        // Init visibility based Pulse view tracking
        initPulseImpressionTracker: function() {
            var placement = this.props.placement;

            if (!!placement && placement.length > 0) {
                var $selector = $('.content-ad.' + placement);
                if (!$selector || $selector.length < 1) {
                    return;
                }

                var deactivate = trackVisibility(
                    $selector,
                    _.bind(function (el) {
                        if (el.visible) {
                            Pulse.ready(
                                this.getPulseOptions('View'),
                                this.state.trackerId
                            );

                            if (this.state.deactivateVisibilityTracker) {
                                this.state.deactivateVisibilityTracker();
                            }

                            var ad = this.state.list[0];

                            if (ad && ad.trackingPixel) {
                                lib.loadImage(ad.trackingPixel);
                            }
                        }
                    }, this),
                    0
                );

                this.setState({
                    deactivateVisibilityTracker: deactivate,
                });
            }
        },

        trackClick: function() {
            // Track Pulse click event
            if (this.props.placement && this.state.tracker) {
                Pulse.ready(
                    this.getPulseOptions('Engagement'),
                    this.state.trackerId
                );
            }

            // Native ad click trackers
            if (this.props.native && this.props.native[0].clickTrackers) {
                if (Array.isArray(this.props.native[0].clickTrackers)) {
                    for (var i in this.props.native[0].clickTrackers) {
                        lib.loadImage(this.props.native[0].clickTrackers[i]);
                    }
                } else {
                    lib.loadImage(this.props.native[0].clickTrackers);
                }
            }
        },

        getPulseOptions: function(type) {
            var base;
            switch (type) {
                case 'View':
                    break;

                case 'Engagement':
                    base = { action: 'Click' };
                    break;

                default:
                    return function () {};
            }

            var _getOpts = _.bind(function(tracker) {
                var ad = this.state.list[0];

                var originType = Pulse.getPageType();
                var url = Pulse.getPageUrl();

                var options = Object.assign({}, base, {
                    type: type,
                    object: Pulse.getObjectBase('UIElement', {
                        id: this.props.placement,
                        override: {
                            position: this.props.placement,
                            elementType: 'brandstudio-native',
                            name: this.props.placement,
                            custom: {
                                customer: ad.customer,
                            },
                        },
                    }),
                    target: Pulse.getObjectBase('Article', {
                        id: ad.teaserName
                            .replace(/[^a-z0-9\s]/ig, '')
                            .replace(/\s/g, '-')
                            .toLowerCase(),
                        override: {
                            name: ad.title
                                .replace(/<[^>]+>/ig, '')
                                .replace(/[^a-zøæå0-9\s:_–-]/ig, ''),
                            url: ad.url,
                        },
                    }),
                    origin: Pulse.getObjectBase(originType, {
                        forceFields: true,
                        override: {
                            url: url,
                        },
                    }),
                });

                return options;
            }, this);

            // Use saved tracker immediately if available, to prevent lifecycle issues
            if (this.state.tracker) {
                this.state.tracker.track(
                    'trackerEvent',
                    _getOpts(this.state.tracker)
                );
                return function () {};
            }

            // No saved tracker... Return callback which will be called with new tracker instance
            return _.bind(function(tracker) {
                this.setState({
                    tracker: tracker,
                });

                tracker.track('trackerEvent', _getOpts(tracker));
            }, this);
        },

        adjustContainer: function() {
            var container = this.props.element;
            if (
                lib.getArticleId() &&
                container.getAttribute('id') === 'ad-netboard_1'
            ) {
                lib.raf(function () {
                    $('.rightColumn.article-siteboard').css({
                        'margin-top': $(container).height() + 20,
                    });
                });
            }
        },

        getOptions: function(article) {
            var isNative = !!this.props.native;
            var skin = isNative ? this.props.native[0].type : 'content';
            var className = classNames('articles-list', {
                'content-marketing-list': skin === 'content',
                'content-ad': skin === 'content',
                'ad-native': skin !== 'content',
            });

            if (this.props.placement && this.props.placement.length > 0) {
                className += ' ' + this.props.placement;
            }

            var options = {
                sectionClass: className,
                href: article.url,
                target: '_blank',
                onClick: this.trackClick,
            };

            if (isNative) {
                options.jsTracker = this.props.native[0].javascriptTracker;
                options.disclaimer = 'Annonse';
            }

            if (skin === 'content') {
                options.disclaimer = 'Annonsørinnhold';
            }

            return options;
        },

        render: function() {
            if (!this.state.render) {
                return null;
            }

            var article = this.state.list[0];
            var options = this.getOptions(article);

            if (article.htmlVersion) {
                return (
                    React.createElement("section", {className: 'content-ad ' + this.props.placement}, 
                        React.createElement("link", {rel: "stylesheet", href: article.cssSource}), 
                        React.createElement("div", {ref: "contentRef", dangerouslySetInnerHTML: { __html: article.htmlVersion}})
                    )
                )
            }

            return (
                React.createElement("section", {className: options.sectionClass}, 
                    React.createElement("div", {className: "article-header"}, 
                        React.createElement("span", {className: "article-header-text"}, options.disclaimer), 
                        React.createElement("img", {className: "article-header-image", src: article.logo, alt: article.customer})
                    ), 
                    React.createElement("a", {
                        href: options.href, 
                        target: options.target, 
                        onClick: options.onClick, 
                        style: {backgroundImage: 'url(' + article.image + ')'}, 
                        className: "article-image-container df-img-container", 
                        rel: "noopener"}
                    ), 
                    React.createElement("div", {className: "article-content"}, 
                        React.createElement("h3", {className: "title"}, 
                            React.createElement("a", {
                                href: options.href, 
                                target: options.target, 
                                onClick: options.onClick, 
                                dangerouslySetInnerHTML: { __html: article.title}, 
                                rel: "noopener"}
                            )
                        )
                    ), 
                    options.jsTracker && (
                        React.createElement("div", {dangerouslySetInnerHTML: { __html: options.jsTracker}})
                    )
                )
            );
        }
    });

    var List = function(element, config) {
        if (!element) {
            return;
        }

        config = config || {};
        config.element = element;

        if (!config.native) {
            config.placeholder = element.getAttribute('data-placeholder');
            config.placement = element.getAttribute('data-placement');
        }

        React.render(React.createElement(ContentMarketing, React.__spread({},  config)), element);
    };

    return List;
});

